package org.hs_soft.runmynesto.domain.model.home.dashboard

enum class PaymentType(val code: String) {
    // Cash payments
    CASH("110"),

    // EFT payments
    EFT("121"),

    // Credit card payments
    CREDIT_1("122"),
    CREDIT_2("123"),
    CREDIT_3("124"),
    CREDIT_4("125"),
    CREDIT_5("126"),
    CREDIT_6("127"),
    CREDIT_7("128"),
    CREDIT_8("129"),
    CREDIT_9("130"),

    // Customer card payments
    CUSTOMER_CARD_IN_HOUSE("171"),
    CUSTOMER_CARD("172"),
    CREDIT_CUSTOMER("180"),

    // Other payment types
    TIPS("190"),
    REMOVED("254");

    companion object {
        val ALL_CREDIT_TYPES = setOf(
            CREDIT_1.code, CREDIT_2.code, CREDIT_3.code,
            CREDIT_4.code, CREDIT_5.code, CREDIT_6.code,
            CREDIT_7.code, CREDIT_8.code, CREDIT_9.code,
            CUSTOMER_CARD_IN_HOUSE.code, CUSTOMER_CARD.code,
            CREDIT_CUSTOMER.code
        )
    }
}